module.exports = new __parcel__URL__("shop_item_info_divider_short.65ef8a36.png").toString();